const { takeEvery, put } = require("redux-saga/effects");
const { getAxiosHeaders, getService } = require("../../../library/RestAPI");
const { ApiCall_DataSourceTypes, GET_ALL_DATA_SOURCES_TYPES } = require("../../../redux/constants/constants");

function* getDataSources () {
  const options = {
    method: 'GET',
    url: ApiCall_DataSourceTypes,
    headers: getAxiosHeaders(true),
  };
  try {
    const response = yield getService(options);
    if (response && response.status === 200) {
      yield put({
        type: "DATA_SOURCE_TYPE",
        payload: response.data?.content || [],
      });
    }
  } catch (error) {
    console.error("Error fetching data sources:", error);
  }
}

function* alertsSaga() {
  yield takeEvery(GET_ALL_DATA_SOURCES_TYPES, getDataSources);
}

export default alertsSaga;